export default "__VITE_ASSET__CFyWjANh__"